export type ApiErrorDetails = {
  error: string;
  code: number;
  message: string;
};
export interface ApiErrorResponse {
  status: number;
  data: {
    details: ApiErrorDetails;
    error: string;
  };
}

export type ApiNewErrorPayload = {
  code: string;
  message: string;
  details?: Record<string, unknown>;
};

export interface ApiNewErrorResponse {
  status: number;
  data: ApiNewErrorPayload;
}

export type ApiErrorInputsData = {
  [key: string]: string[];
};

export interface ApiErrorInputsResponse {
  data: {
    details: ApiErrorInputsData;
    error: string;
  };
  status: number;
}

export const legacyErrorMessages: Record<number, string> = {
  400: 'Неверный запрос',
  404: 'Не найдено',
  10101: 'Email уже существует',
  10102: 'Не удалось отправить email',
  10103: 'Недействительный или истекший токен',
  10104: 'Пользователь уже подтвержден',
  10105: 'Токен истек',
  10106: 'Слишком много запросов',
  10107: 'Приглашение уже существует',
  10108: 'Ошибка удаления',
  101110: 'Недействительный токен',
  101111: 'Неверный шаг',
  101112: 'Неверный код',
  101113: 'СМС не отправлено',
};
